import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section id="pago" className="py-24 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.15)_0%,rgba(10,10,10,1)_70%)] text-center relative bg-brand-dark" data-id="element-84">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-85">
        <img src="https://i.postimg.cc/MTrp95CY/banner-44863-optimized.webp" alt="Megapack" className="mx-auto w-full max-w-2xl mb-10 drop-shadow-[0_0_30px_rgba(212,175,55,0.2)]" data-id="element-86" />

        <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-87">
          El Tiempo No Juega a tu Favor
        </h2>
        <p className="text-xl text-gray-300 mb-10 font-light max-w-2xl mx-auto" data-id="element-88">
          Cada día que pospones la decisión, más folículos se asfixian
          irreversiblemente. Tienes frente a ti el mapa de salida por{' '}
          <span className="text-brand-gold font-bold" data-id="element-89">solo USD12.</span>
        </p>

        <div className="flex flex-col items-center" data-id="element-90">
          <CTAButton href="https://pay.hotmart.com/R104790374J?checkoutMode=10" className="shadow-[0_0_40px_rgba(212,175,55,0.3)]" data-id="element-91" />
        </div>
      </div>
    </section>;
}